(() => {
  const initialize = (root = document) => {
    root.querySelectorAll('[data-aries-project-form]').forEach(form => {
      if (form.dataset.enhanced) return;
      form.dataset.enhanced = 'true';
      const types = Array.from(form.querySelectorAll('input[name="contact[Project type]"]'));
      const groups = Array.from(form.querySelectorAll('[data-project-specific]'));
      const params = new URLSearchParams(location.search);
      const project = params.get('project');
      const initial = types.find(input => input.value === project);
      if (initial) initial.checked = true;
      const piece = (params.get('piece') || '').slice(0,200);
      const pieceField = form.querySelector('[data-project-piece]');
      const pieceLabel = form.querySelector('[data-project-piece-label]');
      if (piece && pieceField && pieceLabel) {
        pieceField.value = piece;
        pieceLabel.querySelector('strong').textContent = piece;
        pieceLabel.hidden = false;
      }
      const updateGroups = () => {
        const selected = types.find(input => input.checked)?.value;
        groups.forEach(group => {
          const active = group.dataset.projectSpecific === selected;
          group.hidden = !active;
          group.querySelectorAll('input,select,textarea').forEach(input => input.disabled = !active);
        });
      };
      const summary = form.querySelector('[data-project-summary]');
      const summaryList = form.querySelector('[data-project-summary-list]');
      const updateSummary = () => {
        if (!summary || !summaryList) return;
        summaryList.replaceChildren();
        const finalStep = Array.from(form.querySelectorAll('[data-aries-step]')).at(-1);
        form.querySelectorAll('input,select,textarea').forEach(input => {
          if (input.disabled || input.type === 'hidden' || !input.value.trim() || (input.type === 'radio' && !input.checked) || finalStep?.contains(input)) return;
          const label = input.labels?.[0]?.textContent.trim();
          if (!label) return;
          const value = input.tagName === 'SELECT' ? input.selectedOptions[0]?.textContent.trim() : input.type === 'radio' ? label : input.value;
          const row = document.createElement('div');
          const term = document.createElement('dt');
          const detail = document.createElement('dd');
          term.textContent = input.type === 'radio' ? form.querySelector('legend')?.textContent.replace(/^1\.\s*/, '') : label;
          detail.textContent = value;
          row.append(term,detail); summaryList.append(row);
        });
        summary.hidden = summaryList.children.length === 0;
      };
      types.forEach(input => input.addEventListener('change', updateGroups));
      form.addEventListener('change', updateSummary);
      form.querySelector('[data-aries-next]')?.addEventListener('click', updateSummary);
      form.querySelectorAll('[data-project-photo-email]').forEach(link => {
        const original = new URL(link.href);
        link.addEventListener('click', () => {
          const name = form.querySelector('input[name="contact[name]"]')?.value.trim() || '';
          const type = types.find(input => input.checked)?.labels?.[0]?.textContent.trim() || '';
          const mail = new URL(original);
          mail.searchParams.set('body', [name,type,piece].filter(Boolean).join('\n') + '\n\n');
          link.href = mail.toString();
        });
      });
      updateGroups();updateSummary();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
